<!--

	Page-level Vue root for Standard layouts that applies site theme tokens
	around the SSR page shell and `#Form`.

	`#appContainer` is the preferred Teleport target for themed page UI so
	content inherits ColorContainer variables without nested ColorContainers.

	NOTE: `.mia-Page` (and classes like Bootstrap `.container`) are rendered by
	C# as slot content so they apply on first paint before this component mounts.

-->
<template>
	<color-container :theme="theme">
		<div id="appContainer" class="mia-AppContainer">
			<slot />
		</div>
	</color-container>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { ColorContainer, type ThemeName } from "@miaplaza/mia-colors";

export default defineComponent({
	name: "AppContainer",
	components: {
		ColorContainer,
	},
	inheritAttrs: false,
	props: {
		/**
		 * Theme name to apply for the whole app using the mia-colors package.
		 */
		theme: {
			type: String as PropType<ThemeName>,
			required: true,
		},
	},
});
</script>
<style lang="scss">
.mia-AppContainer {
	display: flex;
	flex-direction: column;

	> .mia-Page {
		flex: 1 0 auto;
	}
}

@media(max-width: theme.$grid-float-breakpoint) {
	.mia-AppContainer > .mia-Page {
		width: 100%;
	}
}
</style>
